
import { mapGetters } from 'vuex'
import { applyReactInVue } from 'vuereact-combined'
import {
  CardProject,
  ShopList,
  Header,
  ShopListHorizontalScroll,
  UpdateListHorizontal,
  ProjectListHorizontalScroll,
  ArtistListHorizontalScroll
} from '~/react'
import { isEmpty, isNotEmpty, labelCurrency, projectCardContext } from '~/utils/common'
import { labelPrice, formatPrice, labelProjectStatus, getLabelProjectStatus, getLabelProjectRemainDate } from '~/utils/project'
import codeConst from '~/utils/codeConst'

export default {
  name: 'Home',
  directives: {},
  components: {
    RCardProject: applyReactInVue(CardProject),
    RShopListMain: applyReactInVue(ShopList),
    RHeader: applyReactInVue(Header),
    RShopListHorizontalScroll: applyReactInVue(ShopListHorizontalScroll),
    RUpdateListHorizontal: applyReactInVue(UpdateListHorizontal),
    RProjectListHorizontalScroll: applyReactInVue(ProjectListHorizontalScroll),
    RArtistListHorizontalScroll: applyReactInVue(ArtistListHorizontalScroll)
  },
  filters: {},
  meta: {
    fullSize: true
  },
  data() {
    return {
      STATUS: codeConst.STATUS,
      PROJECT_PROJECT_TYPE: codeConst.PROJECT_PROJECT_TYPE,
      FUNDING_SUB_TYPE: codeConst.FUNDING_SUB_TYPE(this),
      activeSwiper: false,
      isLoading: false,
      show: false,
      deviceInPage: 'PC',
      slideOption: {
        loop: true,
        centeredSlides: true,
        initialSlide: 0,
        centeredSlidesBounds: true,
        centerInsufficientSlides: true,
        setWrapperSize: true,
        navigation: {
          nextEl: '.swiper-button-next2',
          prevEl: '.swiper-button-prev2'
        },
        pagination: {
          clickable: true,
          el: '.swiper-pagination'
        }
        // slidesPerGroupSkip: 0
      },
      activeIndex: 1,
      carouselList: [],
      hotProject: {},
      recommandList: [],
      progressList: [],
      recomList: [],
      newList: [],
      updateList: [],
      artistList: [],
      chartList: [],
      movieOn: false,
      movieObj: {},
      model: '',
      colors: [
        'primary',
        'secondary',
        'yellow darken-2',
        'red',
        'orange'
      ],
      slideView: 'auto',
      interval: null,
      votingFilterParams: {
        10: this.$t('main.votingTime.onetime', { amount: 1 }),
        20: this.$t('main.votingTime.onceHour', { amount: 1, time: 1 }),
        30: this.$t('main.votingTime.onceHour', { amount: 1, time: 6 }),
        40: this.$t('main.votingTime.onceHour', { amount: 1, time: 12 }),
        50: this.$t('main.votingTime.onceADay', { amount: 1 }),
        60: this.$t('main.votingTime.infinity')
      },
      fundingType: {
        10: this.$t('main.limitQuantity'),
        20: this.$t('main.limitTime'),
        30: this.$t('main.exclusivePreorder'),
        40: this.$t('main.exclusive'),
        50: this.$t('main.preorder')
      },
      hotProjectMeta: {
        title: '',
        description: '',
        image: '',
        url: ''
      },
      VOTING_TYPE: codeConst.VOTING_TYPE(this),
      codeConst
    }
  },
  head() {
    return {
      title: 'Make Your Own Star (K-pop,drama,movie) | MAKESTAR',
      meta: [
        {
          name: 'title',
          content: 'Makestar : Make Your Own Star!'
        },
        {
          hid: 'description',
          name: 'description',
          content: this.$t('project.index.description')
        },
        {
          property: 'og:title',
          content: 'Makestar : Make Your Own Star!'
        },
        {
          property: 'og:description',
          content: this.$t('project.index.description')
        },
        {
          property: 'og:image',
          content: this.$root.context.env.WEB_URL + '/image/makestar_logo_og_v2.png'
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:url',
          content: this.$root.context.env.WEB_URL + this.$root.context.route.path
        },
        {
          property: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          property: 'twitter:title',
          content: 'K-Portal : Make Your Own Star (K-pop,drama,movie)'
        },
        {
          property: 'twitter:description',
          content: this.$t('project.index.description')
        },
        {
          property: 'twitter:image',
          content: this.$root.context.env.WEB_URL + '/image/makestar_logo_og_v2.png'
        }
      ],
      link: [
        { rel: 'canonical', href: this.$root.context.env.WEB_URL + this.$root.context.route.path },
        {
          rel: 'alternate',
          href: this.$root.context.env.WEB_URL + this.$root.context.route.path + '?lang=en',
          hreflang: 'en'
        },
        {
          rel: 'alternate',
          href: this.$root.context.env.WEB_URL + this.$root.context.route.path + '?lang=ko',
          hreflang: 'ko'
        },
        {
          rel: 'alternate',
          href: this.$root.context.env.WEB_URL + this.$root.context.route.path + '?lang=ja',
          hreflang: 'ja'
        },
        {
          rel: 'alternate',
          href: this.$root.context.env.WEB_URL + this.$root.context.route.path + '?lang=zh',
          hreflang: 'zh'
        },
        {
          rel: 'alternate',
          href: this.$root.context.env.WEB_URL + this.$root.context.route.path + '?lang=es',
          hreflang: 'es'
        }
      ]
    }
  },
  computed: {
    swiperOption() {
      return { ...this.slideOption, slidesPerView: this.device === 'PC' ? 3 : 1 }
    },
    ...mapGetters([
      'device'
    ]),
    newListDisplayData() {
      return this.newList.slice(0, 3)
    },
    recomListDisplayData() {
      return this.recomList.slice(0, 6)
    },
    progressProjectsDisplayData() {
      if (this.device === 'PC') {
        return this.progressList.slice(0, 3)
      } else {
        return this.progressList.slice(0, 6)
      }
    }
  },
  watch: {
    device(newValue, oldValue) {
      if (this.isLoading) {
        this.activeSwiper = false
        setTimeout(() => {
          this.activeSwiper = true
        }, 500)
      }
    }
  },
  created() {},
  async mounted() {
    let allRes = []
    // const a = await getData('main_hard_coding')
    const a = await this.$makeStarApi.external.getS3RemoteConfig('main_hard_coding')
    if (a) {
      const importData = [
        await import('../peaktime/projectE.mjs'),
        await import('../peaktime/project.mjs'),
        await import('../peaktime/projectUpdate.mjs'),
        // await import('../peaktime/artist.mjs'),
        await import('../peaktime/shopingHome.mjs'),
        await import('../peaktime/shoping.mjs')
      ]

      for (const item of importData) {
        allRes.push(item.default)
      }
    } else {
      allRes = [
        await this.$makeStarApi.board.mainProjectEctList({ lang: this.$i18n.locale }),
        await this.$makeStarApi.main.mainProjectList({ lang: this.$i18n.locale }),
        await this.$makeStarApi.main.mainProjectUpdateList({ lang: this.$i18n.locale, pageIdx: 1, pageSize: 3 }),
        // await this.$actchartApi.actchart.fetchSearchPestsList({ date: this.$dayjs().subtract(1, 'd').format('YYYYMMDD') }),
        await this.$makeStarApi.shopping.fetchShoppingHomData({ langCd: this.$i18n.locale }),
        await this.$makeStarApi.shopping.getShoppingList({
          pageIdx: 1,
          pageOffset: 0,
          pageSize: 4,
          pdCd: '',
          langCd: this.$i18n.locale,
          dpCtgrCd: 'DCI010', // 전시 카테고리 코드
          pdOrderBy: 'N',
          excludingSoldOut: true, // 품절상품 제외;
          shoppingCategory: 2
        }),
        await this.$makeStarApi.artist.getArtistTrendingList()
      ]
    }

    const { bannerList = [] } = allRes[0].resData || {}
    this.carouselList = bannerList || []
    const { hotProject = {}, recommendProjects = [], runProjects = [] } = allRes[1].resData || {}
    this.hotProject = hotProject || {}
    this.recommandList = recommendProjects || []
    this.progressList = runProjects || []

    const { list: OriginUpdatList = [] } = allRes[2].resData || {}
    this.updateList = OriginUpdatList.map((updateItem) => {
      return {
        ...updateItem,
        formattedDate: {
          ...this.commentTimeFormatted(updateItem.openDate)
        }
      }
    }) || []

    // const { data: value3 = [] } = allRes[3] || {}

    // const chartRes = value3 || []
    // if (chartRes.length > 0) {
    //   const tempChartList = []
    //   if (chartRes && chartRes.length > 5) {
    //     for (let i = 0; i < 5; i++) {
    //       tempChartList.push(chartRes[i])
    //       tempChartList[i].thumbnailImg = tempChartList[i].YOUTUBE_ID.split('v=')[1]
    //     }
    //   }
    //   this.chartList = tempChartList
    // }

    const { recomList = [] } = allRes[3].resData || {}
    this.recomList = recomList || []
    const { pdList = [] } = allRes[4].resData || {}
    this.newList = pdList || []
    const { brands = [] } = allRes[5].resData || {}
    this.artistList = brands || []
    if (this.artistList.length > 7) { // 트랜드 아티스트 기준으로 7개 아티스트까지 표시
      this.artistList = this.artistList.splice(0, 6)
    }

    setTimeout(() => {
      this.$store.dispatch('modules/layout/setHeaderViewStatus', true)
      this.isReadyState = setInterval(() => {
        if (document.readyState === 'complete') {
          // setTimeout(() => {
          //   this.isLoading = true
          //   this.activeSwiper = true
          //   this.interval = setInterval(() => {
          //     this.onSlideNavigation(true)
          //   }, 5000)
          // }, 500)
          clearInterval(this.isReadyState)
        }
      }, 100)
    }, 100)
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval)
    }
    if (this.isReadyState) {
      clearInterval(this.isReadyState)
    }
  },
  methods: {
    isNotEmpty,
    labelProjectStatus,
    getLabelProjectStatus,
    getLabelProjectRemainDate,
    labelCurrency,
    labelPrice,
    formatPrice,
    projectCardContext,
    handleRouting(flag, id, updateNo) { // PROJECT(배너, 인기, 추천, 진행), UPDATE, ARTIST, CHART, VOTE, COMMUNITY, PRTNERSHIP, FANMADE
      switch (flag) {
        case 'PROJECT':
          this.routePush('/projects/' + id + '/story')
          break
        case 'UPDATE':
          this.routePush('/projects/' + id + '/update/detail?orderNo=' + updateNo)
          break
        case 'ARTIST':
          this.routePush('/artists/' + id)
          break
        case 'EVENT':
          this.routePush('/contents/articles/detail/' + id)
          break
        case 'PARTNERSHIP':
          this.routePush('/partnership')
          break
        case 'VOTE':
          this.routePush('/contents/polls/detail/' + id)
          break
        case 'FANMADE':
          window.document.location = 'https://docs.google.com/forms/d/12I2UWfWL8ymiRWBgGtaaPlDM2ZivOJQFQLPNz_cgKvE/viewform?edit_requested=true&pli=1'
          break
      }
    },
    goProjectDetail(id) {
      this.routePush('/projects/' + id + '/story')
    },
    goShopDetail(pdCd) {
      this.routePush('/shop/' + pdCd)
    },
    onPlayMovie(item) {
      this.movieOn = true
      this.movieObj = item
    },
    slideChangeTransitionStart() {
      this.activeIndex = this.mySwiper.activeIndex
    },
    onSlideNavigation(directToNext) {
      if (directToNext) {
        this.mySwiper.slideNext(1000)
      } else {
        this.mySwiper.slidePrev(1000)
      }
    },
    onClickBannerWapper() {
      const el_active = window.event.currentTarget.getElementsByClassName('swiper-slide-active')[0]
      const idx_slide = el_active.getAttribute('data-swiper-slide-index')
      const idx_data = idx_slide ? parseInt(idx_slide) : 0
      this.onHandleBanner(this.carouselList[idx_data])
    },
    onHandleBanner(data) {
      // data.linkTarget : 링크 타켓 (_self, _blank: 새창)
      // data.linkType : none(연결없음) , proj(프로젝트), url(url연결)
      // data.linkUrl
      switch (data.linkType) {
        case 'PROJ':
          this.handleRouting('PROJECT', data.projectId)
          break
        case 'URL':
          if (data.linkTarget === '_self') {
            window.location = data.linkUrl
          } else {
            window.open(data.linkUrl, '_blank')
          }
          break

        case 'NONE':
          return
      }
    },
    labelUpdateTitle(title) {
      if (isEmpty(title)) {
        return ''
      }
      const split = title.split(':')

      if (split.length >= 2) {
        return split[2]
      } else {
        return split[0]
      }
    },
    handleUpdateProject(value, index) {
      this.updateList[index].isShow = value

      this.$forceUpdate()
    },
    // async setHotProjectMetaInfo() {
    //   const res = await axios.get(process.env.WEB_URL + '/projects/' + this.hotProject.id + '/story')

    //   const parser = new DOMParser()
    //   const htmlDoc = parser.parseFromString(res.data, 'text/html')

    //   const title = this.getContent(htmlDoc, 'meta', 'og:title')
    //   this.hotProjectMeta.title = title

    //   const description = this.getContent(htmlDoc, 'meta', 'og:description')
    //   this.hotProjectMeta.description = description

    //   const image = this.getContent(htmlDoc, 'meta', 'og:image')
    //   this.hotProjectMeta.image = image

    //   const url = process.env.WEB_URL + '/projects/' + this.hotProject.id + '/story'
    //   this.hotProjectMeta.url = url

    //   console.log('this.hotProjectMetat', this.hotProjectMeta)
    // },
    getContent(htmlDoc, tag, property) {
      const metas = htmlDoc.getElementsByTagName(tag)

      for (let i = 0; i < metas.length; i++) {
        if (metas[i].getAttribute('property') === property) {
          return metas[i].getAttribute('content')
        }
      }

      return ''
    },
    routerPush(path) {
      this.$router.push(path)
    },
    goToArtistDetail(idx) {
      this.$router.push({ path: '/artists/' + idx })
    },
    getCardContext(item) {
      return projectCardContext(this, item, this.$i18n.locale)
    },
    getProjectOrderStatus(item) {
      if (isEmpty(item)) {
        return ''
      }

      if (item.status === this.STATUS['30'] || item.status === this.STATUS['40']) {
        return 'COMING SOON'
      }

      if (item.projectType === this.PROJECT_PROJECT_TYPE.FUNDING) {
        if (this.$i18n.locale === codeConst.LANGUAGE.ZH) {
          return this.$i18n.t('project.groupBuying')
        }
        return Math.ceil(item.percent) + '%'
      }

      if (isEmpty(item.fundingSubtype)) {
        return this.$t('project.preOrder')
      }

      return this.FUNDING_SUB_TYPE[item.fundingSubtype].NM
    },
    getProjectlabelPriceNow(item) {
      if (isEmpty(item)) {
        return ''
      }

      if (item.status === this.STATUS['30'] || item.status === this.STATUS['40']) {
        return ''
      }

      if (item.projectType === this.PROJECT_PROJECT_TYPE.FUNDING) {
        if (this.$i18n.locale === codeConst.LANGUAGE.ZH) {
          return ''
        }

        let currencyInfo = item.currencyInfo

        if (isEmpty(item.currencyInfo)) {
          currencyInfo = this.labelCurrency()
        }

        return this.formatPrice(currencyInfo, this.labelPrice(item.amount, this.$i18n.locale))
      }

      if (isEmpty(item.fundingSubtype)) {
        return ''
      }
      return ''
    },
    getProjectDetailUrl(projectId) {
      console.log(projectId)
      return process.env.WEB_URL + '/projects/' + projectId + '/story'
    },
    commentTimeFormatted(dt) {
      try {
        const offset = this.$dayjs().utcOffset()
        const localText = this.$dayjs.utc(dt).utcOffset(offset).format()
        const now = this.$dayjs()
        const localTextFormat = this.$dayjs(localText)
        const ago = {
          min: now.diff(localTextFormat, 'minute'),
          hour: now.diff(localTextFormat, 'hour'),
          day: now.diff(localTextFormat, 'day'),
          month: now.diff(localTextFormat, 'month'),
          year: now.diff(localTextFormat, 'year')
        }

        const result = {
          formatted: '',
          suffixI18n: ''
        }

        if (ago.min < 60) { // 1시간 내
          result.formatted = ago.min
          result.suffixI18n = 'filters.fewMinutesAgo'
        } else if (ago.hour < 24) { // 하루 내
          result.formatted = ago.hour
          result.suffixI18n = 'filters.fewHoursAgo'
        } else if (ago.day >= 1 && ago.day <= 31) { // 하루 이상
          result.formatted = ago.day
          result.suffixI18n = 'filters.fewDayAgo'
        } else if (ago.month <= 12) {
          result.formatted = ago.month
          result.suffixI18n = 'filters.fewMonthAgo'
        } else {
          result.formatted = ago.year
          result.suffixI18n = 'filters.fewYearsAgo'
        }
        // console.log(result)

        return result
      } catch {
        return {
          formatted: '',
          suffixI18n: ''
        }
      }
    }
  }
}
